import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import Link from '@welldev-group/rcl-link';
import Icon from '@welldev-group/rcl-icon';
import SidePanel from '@welldev-group/rcl-sidepanel';
import SanitizedHTML from '../../../../SanitizedHTML';

const GeneralInformationLink = ({ generalInformation }) => {
  const [openSidePanel, setOpenSidePanel] = useState(false);

  const showSidePanel = () => {
    setOpenSidePanel(true);
  };

  const hideSidePanel = () => {
    setOpenSidePanel(false);
  };

  return (
    <Fragment>
      <Link onClick={showSidePanel} modifier="tertiary" size="tiny">
        <Icon
          className="general-information"
          name="remarks"
          size="tiny"
          color="default"
          showLabel={true}
          iconLabel={I18n.t('components.ibe.search_results.hotel.general_information')}
        />
      </Link>
      <SidePanel
        className="general-information__side-panel"
        title={I18n.t('components.ibe.search_results.hotel.general_information')}
        isOpened={openSidePanel}
        onOpen={showSidePanel}
        onClose={hideSidePanel}
      >
        <SanitizedHTML
          html={generalInformation}
          className="hotel-information__additional-info-elements"
        />
      </SidePanel>
    </Fragment>
  );
};

GeneralInformationLink.propTypes = {
  generalInformation: PropTypes.string.isRequired,
};

export default GeneralInformationLink;
